module.exports = __webpack_public_path__ + "static/media/premium-packs-icon.6a9c9743.svg";